import {ISystemComponent} from '@gongxigames/framework/core/types';

export interface IService extends ISystemComponent {

}
